export default "__VITE_ASSET__Co4wD9Bp__"